import { useLoadingStore } from '../../stores/loadingStore'
import type { LoadingStepStatus } from '../../stores/loadingStore'
import '../../styles/loading.css'

function stepIcon(status: LoadingStepStatus): string {
  switch (status) {
    case 'done':
      return '\u2713'
    case 'error':
      return '\u2717'
    default:
      return '\u25CB'
  }
}

function stepClass(status: LoadingStepStatus): string {
  switch (status) {
    case 'done':
      return 'loading-overlay__step--done'
    case 'error':
      return 'loading-overlay__step--error'
    default:
      return 'loading-overlay__step--pending'
  }
}

export default function LoadingOverlay() {
  const steps = useLoadingStore((s) => s.steps)
  const visible = useLoadingStore((s) => s.visible)

  if (!visible || steps.length === 0) return null

  const doneCount = steps.filter((s) => s.status === 'done').length
  const progress = Math.round((doneCount / steps.length) * 100)

  return (
    <div className="loading-overlay">
      <div className="loading-overlay__card">
        <div className="loading-overlay__spinner" />
        <h2 className="loading-overlay__title">Chargement en cours</h2>
        <div className="loading-overlay__progress-bar">
          <div
            className="loading-overlay__progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
        <span className="loading-overlay__progress-text">{progress}%</span>
        <ul className="loading-overlay__steps">
          {steps.map((step) => (
            <li
              key={step.name}
              className={`loading-overlay__step ${stepClass(step.status)}`}
            >
              <span className="loading-overlay__step-icon">
                {stepIcon(step.status)}
              </span>
              <span className="loading-overlay__step-name">{step.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
